"use strict";
function isFunction(x) {
    return typeof x === 'function';
}
exports.isFunction = isFunction;
//# sourceMappingURL=isFunction.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rxjs@5.4.3@rxjs/util/isFunction.js
// module id = 137
// module chunks = 0